/* ER · Dynamic percent-off sale badges
   Replaces the theme's generic "Sale" badge with the real discount,
   computed per product from compare-at vs current price.
   Works on collection grids, search, related products, and PDPs. */
(function () {
  'use strict';

  var CARD = '.card-wrapper, .product-card-wrapper, .card, .grid__item, .featured-product';

  function toNumber(text) {
    if (!text) return NaN;
    var s = String(text).replace(/[^\d.,]/g, '').trim();
    if (!s) return NaN;
    var lastComma = s.lastIndexOf(',');
    var lastDot = s.lastIndexOf('.');
    if (lastComma > lastDot) {
      s = s.replace(/\./g, '').replace(',', '.');
    } else {
      s = s.replace(/,/g, '');
    }
    return parseFloat(s);
  }

  function firstText(root, selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var el = root.querySelector(selectors[i]);
      if (el && el.textContent.trim()) return el.textContent;
    }
    return '';
  }

  function decorate(priceEl) {
    var regular = toNumber(firstText(priceEl, [
      '.price__sale s.price-item--regular',
      '.price__sale .price-item--regular',
      's.price-item--regular'
    ]));
    var sale = toNumber(firstText(priceEl, [
      '.price__sale .price-item--sale',
      '.price-item--sale'
    ]));

    if (!isFinite(regular) || !isFinite(sale)) return;
    if (regular <= 0 || sale >= regular) return;

    var pct = Math.round((1 - sale / regular) * 100);
    if (pct < 1 || pct > 99) return;
    var label = pct + '% OFF';

    var targets = [];
    var inline = priceEl.querySelector('.price__badge-sale');
    if (inline) targets.push(inline);

    var card = priceEl.closest(CARD);
    if (card) {
      card.querySelectorAll('.card__badge .badge, .badge.badge--bottom-left').forEach(function (b) {
        targets.push(b);
      });
    }

    targets.forEach(function (b) {
      if (b.getAttribute('data-er-sale') === label) return;
      if (/sold\s*out|unavailable|out of stock/i.test(b.textContent)) return;
      b.textContent = label;
      b.classList.add('er-sale-badge');
      b.setAttribute('data-er-sale', label);
    });
  }

  function run(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.price--on-sale').forEach(decorate);
  }

  function boot() {
    run(document);

    var pending = null;
    if (window.MutationObserver && document.body) {
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(function () { run(document); }, 60);
      }).observe(document.body, { childList: true, subtree: true });
    }

    // Re-run after theme editor section reloads and facet/variant re-renders
    document.addEventListener('shopify:section:load', function (e) { run(e.target); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();